/**
 * Signals that there was a network related error
 */
export class InternetConnectionError extends Error {
    __proto__: Error; // tslint:disable-line:variable-name
    constructor() {
        const trueProto = new.target.prototype;
        super("There is a problem with your Internet connection");

        this.__proto__ = trueProto;
    }
}

/**
 * Signals that the fetch was cancelled because you called 'abort'
 */
export class FetchAbortedError extends Error {
}

export interface AbortableAction {
    abort(): void;
}

/**
 * Thin wrapper around XMLHttpRequest
 */
export class HttpRequest implements AbortableAction {
    public constructor(
        private method: string,
        private url: string,
        private headers: [string, string][],
        private body: FormData | string | null
    ) {
        this.http = new XMLHttpRequest();
    }

    private readonly http: XMLHttpRequest;
    private fetched = false;
    private aborted = false;

    /**
     * May be called after 'fetch' has been called (but before fetch has returned)
     * in order to abort the in-progress request. The fetch
     */
    public abort(): void {
        if (!this.fetched) {
            throw new Error("Illegally called HttpRequest.abort when not yet called fetched");
        }
        if (this.aborted) {
            throw new Error("Illegally called HttpRequest.abort a second time");
        }
        // TODO Maybe also check that the request has not succesfully completed?
    }

    /**
     * Resolves with the response from the web server. You should not do anything
     * with the resulting XMLHttpRequest object other than read the following fields:
     *
     *   status
     *   satusTest
     *   responseText
     *   getResponseHeader()
     *   getAllResponseHeaders()
     *
     */
    public fetch(): Promise<XMLHttpRequest> {
        if (this.fetched) {
            throw new Error("Illegally called HttpRequest.fetch a second time");
        }
        this.fetched = true;
        return new Promise<XMLHttpRequest>((resolve, reject) => {
            this.http.open(this.method, this.url);
            for (const [header, headerVal] of this.headers) {
                this.http.setRequestHeader(header, headerVal);
            }
            this.http.onload = () => {
                resolve(this.http);
            };

            this.http.onerror = (err: any) => {
                console.log("onerror", err);
                reject(new InternetConnectionError());
            };
            if (this.body !== null) {
                this.http.send(this.body);
            } else {
                this.http.send();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/HttpRequest.ts